import { removeSuffix3d61x5lsuvuho as removeSuffix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function bestGuessAtAppName(_this__u8e3s4) {
  return removeSuffix(window.location.hostname, '.com');
}
//region block: exports
export {
  bestGuessAtAppName as bestGuessAtAppName22d8w4clezb4c,
};
//endregion

//# sourceMappingURL=metadata.js.mjs.map
